import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CTAButton } from './ui/CTAButton';
import { trackAddToCart } from '../utils/metaPixel';
export function OfferSection() {
  return <section id="offer-section" className="py-12 md:py-14 px-6 bg-navy text-white relative overflow-hidden" data-id="element-98">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gold/5 rounded-full blur-3xl pointer-events-none" data-id="element-99"></div>

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-100">
        <FadeIn data-id="element-101">
          <h2 className="font-serif text-2xl md:text-4xl mb-4" data-id="element-102">
            Recupera el dominio de tu mañana hoy mismo.
          </h2>
        </FadeIn>

        <FadeIn delay={0.15} data-id="element-103">
          <p className="text-base text-white/80 mb-8 max-w-2xl mx-auto" data-id="element-104">
            El acceso al Método 7-D Mornings completo tiene un valor simbólico
            para asegurar que nadie se quede fuera por falta de recursos.
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-105">
          <div id="offer-cta" className="bg-white/5 border border-white/10 rounded-2xl p-6 md:p-8 backdrop-blur-sm max-w-md mx-auto mb-8" data-id="element-106">
            <p className="text-white/60 uppercase tracking-widest text-xs mb-3 font-medium" data-id="element-107">
              Precio Único
            </p>
            <div className="flex flex-col items-center gap-1 mb-6" data-id="element-108">
              <div className="flex items-center gap-2" data-id="element-109">
                <span className="text-xl text-white/40 font-serif line-through" data-id="element-110">
                  $17
                </span>
                <span className="text-xs uppercase tracking-wider bg-gold/20 text-gold px-2.5 py-0.5 rounded-full font-semibold" data-id="element-111">
                  -63% OFF
                </span>
              </div>
              <div className="flex items-center gap-1" data-id="element-112">
                <span className="text-2xl text-gold font-serif" data-id="element-113">$</span>
                <span className="text-5xl md:text-6xl font-serif text-white" data-id="element-114">
                  6.36
                </span>
                <span className="text-lg text-white/60 self-end mb-1" data-id="element-115">USD</span>
              </div>
            </div>

            <CTAButton href="https://inerciacero.com/cart/42357278605415:1" onClick={() => trackAddToCart()} className="w-full" data-id="element-116">
              QUIERO RECUPERAR MIS MAÑANAS
            </CTAButton>

            <p className="mt-4 text-xs text-white/50" data-id="element-117">
              Tu transformación comienza mañana a primera hora.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}